import Endpoint from './endpoint';
import Model from './model';

module.exports = { Endpoint, Model };
